import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PremisesTableRow } from "../types";

export const usePremisesNavigation = (row: PremisesTableRow) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClick = React.useCallback(() => {
    navigate(`/new-premise/${row.id}?connection=${row.connectionType}`, {
      state: {
        serviceType: row.serviceType,
        backUrl: location.pathname + location.search,
      },
    });
  }, [navigate, row, location.pathname, location.search]);

  return { handleOnClick, navigate, location };
};
